(function ($) {
    "use strict";
    searchSuggest();

    $(function() {

        $('.resource-filter').on('click', function (e) {
            e.preventDefault();
            var ajaxURL = $(this).closest('.resource-landing__page-content').data('search-url');
            $.ajax({
                url: `${ajaxURL}LoadMore`,
                method: 'GET',
                dataType: 'HTML',
                data: { topic: $(this).data('filter-id') }
            }).done(function (html) {
                $('#results-wrap').html(html);
                loadMore();
                singleClickEventRegistration();
            });

            // rotate active class on filter links
            $(this).closest('.resource-landing-sidebar').find('.active').removeClass('active');
            $(this).addClass('active');

            // close open panel when active item is not inside
            $(this).closest('.resource-landing-sidebar__list').find('.resource-landing-sidebar__item').each(function () {
                if (!$(this).find('.active').length && $(this).find('.resource-nav-filter__toggle[aria-expanded="true"]').length) {
                    bootstrap.Collapse.getOrCreateInstance($(this).find('.resource-nav-filter__collapse')).hide();
                }
            });

            // swap resource filter toggle button text with active filter text
            $(this).closest('.resource-landing-sidebar').find('#resourceMobileMenuCollapseToggle').text($(this).text());

            // close resource filter collapse when a filter is clicked
            $(this).closest('.resource-landing-sidebar').find('#resourceMobileMenuCollapse').collapse('hide');

        });

        $('.resource-nav-filter__collapse').on('shown.bs.collapse', function(){

            if(!pageLoadFilter){
            var rootFilterID = $(this).data('root-filter-id');
            var $filterButton = $(this).find('*[data-filter-id="'+ rootFilterID +'"]');
            var ajaxURL = $(this).closest('.resource-landing__page-content').data('search-url');
            $.ajax({
                url: `${ajaxURL}LoadMore`,
                method: 'GET',
                dataType: 'HTML',
                data: { topic: $filterButton.data('filter-id') }
            }).done(function (html) {
                $('#results-wrap').html(html);
                loadMore();
                singleClickEventRegistration();
            });
    
            // rotate active class on filter links
            $filterButton.closest('.resource-landing-sidebar').find('.active').removeClass('active');
            $filterButton.addClass('active');
    
            // close open panel when active item is not inside
            $filterButton.closest('.resource-landing-sidebar__list').find('.resource-landing-sidebar__item').each(function () {
                if (!$(this).find('.active').length && $(this).find('.resource-nav-filter__toggle[aria-expanded="true"]').length) {
                    bootstrap.Collapse.getOrCreateInstance($(this).find('.resource-nav-filter__collapse')).hide();
                }
            });
    
            // swap resource filter toggle button text with active filter text
            $filterButton.closest('.resource-landing-sidebar').find('#resourceMobileMenuCollapseToggle').text($filterButton.text());
    
            // close resource filter collapse when a filter is clicked
            $filterButton.closest('.resource-landing-sidebar').find('#resourceMobileMenuCollapse').collapse('hide');
    
            }
            else{
                pageLoadFilter = false;
            }
        });
    
        // open collapse with active filter by default
        $('.resource-filter.active').closest('.resource-nav-filter__collapse').collapse('show');
        // replace mobile dropdown label text by default
        $('.resource-filter.active').closest('.resource-landing-sidebar').find('#resourceMobileMenuCollapseToggle').text($('.resource-filter.active').text());
    });

})(jQuery);

function searchSuggest(event, element) {
    var queryChangeInterval = null;
    var lastCheckedSearch = null;
    var ajaxUrl = null;
    var requestObject = null;   
    $('#resourceLandingSearchInput').on('keyup', function () {
        clearInterval(queryChangeInterval);
        
        queryChangeInterval = setInterval(function () {
            clearInterval(queryChangeInterval);
            var currentSearch = $('#resourceLandingSearchInput').val();
    
            if (currentSearch === lastCheckedSearch) {
                return;
            }
        
            lastCheckedSearch = currentSearch;
        
            if (requestObject !== null) {
                requestObject.abort();
            }
        
            if (currentSearch.length < 1) {
                // Hide suggestion section
                $('#searchSuggestWrap').addClass('d-none');
                return;
            }
            var ajaxURL = $('#resourceLandingSearchInput').data('search-url');

            requestObject = $.ajax({
                url: `${ajaxURL}SearchSuggest`,
                method: 'GET',
                dataType: 'HTML',
                data: { q: $('#resourceLandingSearchInput').val(), contentLink: $('#resourceLandingSearchInput').data('page-id') }
            }).done(function (html) {
                requestObject = null;
                
                $('#searchSuggestWrap').html(html);
                // Show suggestion section
                $('#searchSuggestWrap').removeClass('d-none');
            }).fail(error => console.log(error));
        }, 100);

    });
}

function singleClickEventRegistration(){
    $('.single-click').each(function () {
        var $this = $(this),
            imgLink = $this.find('a img'),
            down,
            up,
            link = $this.find('a'),
            middleClick,
            linkClick,
            auxClick;

        if (imgLink.length) {
            imgLink.unwrap();
        }

        if (!link.length || link.length > 1) {
            $this.removeClass('single-click');
        }
        else
        {
            $this.on('mousedown', function (e) {
                down = +new Date();
                middleClick = (e.which === 2) ? true : false;
                auxClick = (e.which === 3) ? true : false;
            
                // Prevent two tabs from opening in firefox
                linkClick = $(e.target).is('a') || $(e.target).closest('a').length ? false : true;
            }).on('mouseup', function () {
                up = +new Date();
                if ((up - down) < 200 && auxClick === false && linkClick === true) {
                    link[0].click();
                }
            });
        }
    });
}